import apiClient from './apiClient';

const adminService = {
  // Get dashboard statistics
  getDashboardStats: async () => {
    const response = await apiClient.get('/admin/dashboard');
    return response.data;
  },

  // Sync matches from FIFA website
  syncMatchesFromFIFA: async () => {
    const response = await apiClient.post('/admin/matches/sync');
    return response.data;
  },

  // Update match results
  updateMatchResults: async (matchId, homeScore, awayScore) => {
    const response = await apiClient.put(`/admin/matches/${matchId}/results`, {
      home_score: homeScore,
      away_score: awayScore
    });
    return response.data;
  },

  // Get settings
  getSettings: async () => {
    const response = await apiClient.get('/settings');
    return response.data;
  },

  // Update settings
  updateSettings: async (updates) => {
    const response = await apiClient.put('/settings', updates);
    return response.data;
  },

  // Get public prize info
  getPrizeInfo: async () => {
    const response = await apiClient.get('/settings/prize-info');
    return response.data;
  }
};

export default adminService;